import { render } from "./MedicalView.vue?vue&type=template&id=19fa9318&scoped=true&ts=true"
import script from "./MedicalView.vue?vue&type=script&lang=ts"
export * from "./MedicalView.vue?vue&type=script&lang=ts"

import "./MedicalView.vue?vue&type=style&index=0&id=19fa9318&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fa9318"]])

export default __exports__